<app-header></app-header>
<app-sidebar></app-sidebar>
<ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="timer" [fullScreen]="false">
    <p style="color: white">Loading... </p>
</ngx-spinner>
<div class="content-wrapper" style="min-height: 307px">

    <div class="col-12">
        <div class="row">
            <!-- รถบรรทุก -->
            <div class="card  card-secondary">
                <div class="card-header">
                    <div class="card-title">
                        <i class="fas fa-truck-moving"></i> สถานะรถตัดอ้อย
                    </div>
                    <div class="card-tools">
                        <button type="button" class="btn btn-tool" (click)="LoadTruckdata();"><i
                                class="fas fa-sync"></i>
                        </button>
                        <button type="button" class="btn btn-tool" data-card-widget="collapse"><i
                                class="fas fa-minus"></i>
                        </button>
                    </div>
                </div>
                <div class="card-body">
                    <!--<nav class="main-header navbar navbar-expand navbar-white navbar-light">     
                         Right navbar links
                        <ul class="navbar-nav ml-auto">                     
                           <li class="nav-item" (click)="setDataTeble(2);">                     
                              <div class="navbar-search-block">
                                 <button  [ngClass]="{ 'btn':true, 'active': settap == 2 }" ><i class="fas fa-plus"></i> เพิ่มข้อมูล</button>
                              </div>
                           </li>                          
                         <li class="nav-item" (click)="setDataTeble(1);">
                     
                            <div class="navbar-search-block">
                               <button [ngClass]="{ 'btn':true, 'active':settap == 1}" > <i class="fas fa-truck"></i> ข้อมูลทั้งหมด</button>
                            </div>
                         </li>
                        </ul>
                    </nav> -->

                    <div class="card-body headText">
                        <div class="row" *ngIf="Dataalltruck != null">

                            <div class="col-md-3">
                                <div class="card card-widget widget-user-2">
                                    <div class="card-header p-0">
                                        <div class="small-box bg-info">
                                            <div class="inner">
                                                <h2 style="font-weight: bold;text-align:center;">จำนวนรถตัดทั้งหมด</h2>
                                                <p style="font-weight: bold;text-align:center;color: #fff;">
                                                    {{countdata[0]}} คัน</p>
                                            </div>
                                            <div class="icon">
                                                <i class="	fas fa-chart-bar"></i>
                                            </div>
                                            <a class="small-box-footer" (click)="setDataTeble(0);">
                                                <button [ngClass]="{ 'btn':true, 'active':settap == 0}">คลิกดูข้อมูล <i
                                                        class="fas fa-angle-double-down"></i></button>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card-footer p-0">
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="card card-widget widget-user-2">
                                    <div class="card-header p-0">
                                        <div class="small-box bg-success">
                                            <div class="inner">
                                                <h2 style="font-weight: bold;text-align:center;">จำนวนรถตัดที่ตัดปกติ
                                                </h2>
                                                <p style="font-weight: bold;text-align:center;color: #fff;">
                                                    {{countdata[1]}} คัน</p>
                                            </div>
                                            <div class="icon">
                                                <i class="	fas fa-chart-bar"></i>
                                            </div>
                                            <a class="small-box-footer" (click)="setDataTeble(1);">
                                                <button [ngClass]="{ 'btn':true, 'active':settap == 1}">คลิกดูข้อมูล <i
                                                        class="fas fa-angle-double-down"></i></button>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card-footer p-0">
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="card card-widget widget-user-2">
                                    <div class="card-header p-0">
                                        <div class="small-box bg-warning">
                                            <div class="inner">
                                                <h2 style="font-weight: bold;text-align:center;">จำนวนรถตัดที่ไม่ได้ตัด
                                                </h2>
                                                <p style="font-weight: bold;text-align:center;color: #fff;">
                                                    {{countdata[2]}} คัน</p>
                                            </div>
                                            <div class="icon">
                                                <i class="	fas fa-chart-bar"></i>
                                            </div>
                                            <a class="small-box-footer" (click)="setDataTeble(2);">
                                                <button [ngClass]="{ 'btn':true, 'active':settap == 2}">คลิกดูข้อมูล <i
                                                        class="fas fa-angle-double-down"></i></button>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card-footer p-0">
                                    </div>
                                </div>
                            </div>

                            <div class="col-md-3">
                                <div class="card card-widget widget-user-2">
                                    <div class="card-header p-0">
                                        <div class="small-box bg-danger">
                                            <div class="inner">
                                                <h2 style="font-weight: bold;text-align:center;">จำนวนรถตัดที่เสีย</h2>
                                                <p style="font-weight: bold;text-align:center;color: #fff;">
                                                    {{countdata[3]}} คัน</p>
                                            </div>
                                            <div class="icon">
                                                <i class="	fas fa-chart-bar"></i>
                                            </div>
                                            <a class="small-box-footer" (click)="setDataTeble(3);">
                                                <button [ngClass]="{ 'btn':true, 'active':settap == 3}">คลิกดูข้อมูล <i
                                                        class="fas fa-angle-double-down"></i></button>
                                            </a>
                                        </div>
                                    </div>
                                    <div class="card-footer p-0">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-md-12 ml-md">
                            <table style="width:100%">
                                <tr style="text-align:center">
                                    <th>กำลังตัดสูงสุดรวม</th>
                                    <th>เป้าหมายอ้อยรวม</th>
                                    <th>ปริมาณการตัดอ้อยรวม</th>
                                    <th>เป้าหมายอ้อยรายวันรวม</th>
                                    <th>ปริมาณอ้อยเข้าวันนี้</th>
                                </tr>
                                <tr style="text-align:center">
                                    <td>{{sumdata[0]|number}} ตัน/วัน</td>
                                    <td>{{sumdata[1]|number}} ตัน</td>
                                    <td>{{sumdata[2]|number}} ตัน</td>
                                    <td>{{sumdata[3]|number}} ตัน</td>
                                    <td>{{sumdata[4]|number}} ตัน</td>
                                </tr>
                            </table>
                        </div>
                        <!--<div class="col-md-2 ml-md" >                                                                               
                            <div class="input-group mb-3" [formGroup]="datagoup">       
                                <span class="input-group-text" id="basic-addon2">เลือกโซน</span>             
                                <select class="form-select" formControlName="szone" (change)="setDataTeble(10);">
                                    <option value="" disabled>-- กรุณาเลือก --</option>
                                    <option value="All" selected>All | ข้อมูลทุกกลุ่ม</option>
                                    <option value="P1">P1 | ข้อมูลกลุ่มส่วนที่ 1</option>
                                    <option value="P2">P2 | ข้อมูลกลุ่มส่วนที่ 2</option>
                                    <option value="P3">P3 | ข้อมูลกลุ่มส่วนที่ 3</option>                      
                                    <option value="P4">P4 | ข้อมูลกลุ่มส่วนที่ 4</option>
                                    <option *ngFor="let item of zonecode" [ngValue]="item.SUPZONE">{{item.SUPZONE}} | {{item.ZONENAME}}</option>                        
                                </select>
                            </div>                            
                         </div>-->
                        <hr>
                    </div>

                    <div class="row">
                        <!-- 'carReg','fmname','groupCode','h_fmname','supzone','target_cane','sum_wgt','pc_sum_wgt','canCutMax','canPerDay','sum_wgt24h','pc_canPerDay','last_date','Hourlastcut','check_cut','action'-->
                        <mat-card [formGroup]="datagoup">
                            <mat-card-header>
                                <mat-card-title>ตารางข้อมูล{{txtTap}}</mat-card-title>
                            </mat-card-header>
                            <!--<mat-label></mat-label>-->

                            <mat-form-field appearance="fill">
                                <input matInput (keyup)="applyFilter($event)" placeholder="รายการที่ต้องการหา" #input>
                            </mat-form-field>

                            <mat-form-field appearance="fill">
                                <mat-label> เลือกโซน </mat-label>
                                <select matNativeControl [(ngModel)]="seleczone" formControlName="szone" name="zone"
                                    (change)="setDataTeble(10);">
                                    <option value="" disabled>-- กรุณาเลือก --</option>
                                    <option value="All" selected>All | ข้อมูลทุกกลุ่ม</option>
                                    <option value="P1">P1 | ข้อมูลกลุ่มส่วนที่ 1</option>
                                    <option value="P2">P2 | ข้อมูลกลุ่มส่วนที่ 2</option>
                                    <option value="P3">P3 | ข้อมูลกลุ่มส่วนที่ 3</option>
                                    <option value="P4">P4 | ข้อมูลกลุ่มส่วนที่ 4</option>
                                    <option value="P5">P5 | ข้อมูลกลุ่มส่วนที่ 5</option>
                                    <option *ngFor="let item of zonecode" [value]="item.SUPZONE">
                                        {{item.SUPZONE}} | {{item.ZONENAME}}
                                    </option>
                                </select>
                            </mat-form-field>
                            <!--<p> ตัวเลือก : {{seleczone}} </p>-->

                            <table mat-table [dataSource]="Dataalltruck" matSort style="width: 100%;"
                                *ngIf="Dataalltruck != null" #table>
                                <ng-container matColumnDef="carcutId">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">รหัสรถ</th>
                                    <td mat-cell *matCellDef="let element"> {{element.carcutId}} </td>
                                </ng-container>
                                <ng-container matColumnDef="carReg">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">เลขรถตัด
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.carReg}} </td>
                                </ng-container>

                                <ng-container matColumnDef="fmname">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">เจ้าของรถ
                                    </th>
                                    <td mat-cell *matCellDef="let element" [ngStyle]="{'background-color': (element.supcode!=='Z') ? '#ffffff' :
                                (element.supcode=='Z' && item.Partcode=='BRD') ? '#1C77C3' :
                                (element.supcode=='Z' && item.Partcode!='BRD') ? '#ffdc7d': null }">
                                        {{element.fmname}} </td>
                                </ng-container>

                                <ng-container matColumnDef="groupCode">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">กลุ่มตัด
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.groupCode}} </td>
                                </ng-container>

                                <ng-container matColumnDef="h_fmname">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">
                                        ชื่อหัวหน้ากลุ่ม</th>
                                    <td mat-cell *matCellDef="let element"> {{element.h_fmname}} </td>
                                </ng-container>

                                <ng-container matColumnDef="supzone">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader"> โซน </th>
                                    <td mat-cell *matCellDef="let element"> {{element.supzone}} </td>
                                </ng-container>

                                <ng-container matColumnDef="target_cane">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">
                                        เป้าหมายทั้งหมด</th>
                                    <td mat-cell *matCellDef="let element"> {{element.target_cane | number}} </td>
                                </ng-container>

                                <ng-container matColumnDef="sum_wgt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">ปริมาณตัดAll
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.sum_wgt | number}} </td>
                                </ng-container>

                                <ng-container matColumnDef="pc_sum_wgt">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">%อ้อยเข้า
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.pc_sum_wgt | number}} </td>
                                </ng-container>

                                <ng-container matColumnDef="canCutMax">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">
                                        กำลังตัดสูงสุด</th>
                                    <td mat-cell *matCellDef="let element"> {{element.canCutMax | number}} </td>
                                </ng-container>

                                <ng-container matColumnDef="canPerDay">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">เป้าหมาย/วัน
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.canPerDay | number}} </td>
                                </ng-container>

                                <ng-container matColumnDef="sum_wgt24h">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">
                                        ปริมาณอ้อยวันนี้</th>
                                    <td mat-cell *matCellDef="let element"> {{element.sum_wgt24h | number}} </td>
                                </ng-container>

                                <ng-container matColumnDef="pc_canPerDay">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">%อ้อยวันนี้
                                    </th>
                                    <td mat-cell *matCellDef="let element" [ngClass]="element.pc_canPerDay >= 100 ? 'bg-primary': '' 
                                            || element.pc_canPerDay >= 50 ? 'bg-info' :''
                                            || element.pc_canPerDay < 50 && element.pc_canPerDay > 0 ? 'bg-warning' :''
                                            || element.pc_canPerDay <= 0 ? 'bg-danger' :''
                                            "> {{element.pc_canPerDay | number}} </td>
                                </ng-container>

                                <ng-container matColumnDef="last_date">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">เวลาล่าสุด
                                    </th>
                                    <td mat-cell *matCellDef="let element"> {{element.last_date}} </td>
                                </ng-container>

                                <ng-container matColumnDef="Hourlastcut">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">
                                        หยุดตัด(ชั่วโมง)</th>
                                    <td mat-cell *matCellDef="let element"> {{element.Hourlastcut}} </td>
                                </ng-container>

                                <ng-container matColumnDef="check_cut">
                                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader">
                                        สถานะปัจจุบัน </th>
                                    <td mat-cell *matCellDef="let element">
                                        <p class="bg-success text-white" *ngIf="element.check_cut===1"> ตัด </p>
                                        <p class="bg-warning text-white" *ngIf="element.check_cut===2"> ไม่ตัด </p>
                                        <p class="bg-danger text-white" *ngIf="element.check_cut===3"> เสียซ่อม </p>
                                    </td>
                                </ng-container>

                                <!--
                             <ng-container matColumnDef="action">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header class="matHeader"> ตัวเลือก </th>
                                <td mat-cell *matCellDef="let element" > 
                                    &nbsp;
                                    <button class="btn btn-danger btn-sm" *ngIf="settap == 4"  (click)="CancleTruck(element.TRUCK_NO)"> 
                                        <i class="fas fa-edit" ></i> 
                                    </button>
                                </td>
                            </ng-container>   
                             -->
                                <tr class="headText text-primary" mat-header-row
                                    *matHeaderRowDef="displayedColumns ; sticky: true;"
                                    style="background-color: rgb(100, 185, 250);"></tr>
                                <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>

                                <!-- Row shown when there is no matching data. -->
                                <tr class="mat-row" *matNoDataRow>
                                    <td class="mat-cell" colspan="4">ไม่มีข้อมูลตรงกัน "{{input.value}}"</td>
                                </tr>
                            </table>
                            <mat-paginator [pageSizeOptions]="[10,25,50,100,200]" showFirstLastButtons
                                aria-label="Select page of periodic elements"></mat-paginator>

                        </mat-card>
                    </div>
                </div>
            </div>
        </div>
    </div>
</div>
<app-footer></app-footer>